
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1159:491)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23 34.959h1.77V31.56H23v3.398zm0-5.695c.214.021.43.032.647.032.37 0 .737.018 1.097.037 1.38.07 2.665.136 3.667-.874 1.264-1.275 1.974-4.156 1.974-5.959 0-1.802-.71-4.331-1.974-5.606-1.189-1.199-2.776-1.194-4.448-1.19h-.316c-.217 0-.433.011-.647.032v13.528zm0-15.824h1.77v-3.398H23v3.398zm7.794 14.667l-1.588 1.601 2.382 2.402 1.588-1.601-2.382-2.402zm2.382-13.615l-1.588-1.603v.001l-2.382 2.403 1.588 1.601 2.382-2.402zM36 23.632v-2.264h-3.369v2.265H36z","fill":"#F07300"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1159:491","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1159:491"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1159:491","result":"shape"}})])])])
          )
        }
      }
    